var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mainContent",style:({
    backgroundImage: 'url(' + require('../assets/logo/bg1.png') + ')',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center center',
    backgroundSize: '100%'
  })},[_c('div',{staticClass:"w_content"},[_c('h1',[_vm._v("欢迎登陆超体鼻假体防伪溯源系统")]),_c('p',[_c('span',[_vm._v("上次登陆时间：")]),_c('span',[_vm._v(_vm._s(_vm.timer))])]),_c('p',[_c('span',[_vm._v("上次登陆IP：")]),_c('span',[_vm._v(_vm._s(_vm.ipAddress))])])])])}
var staticRenderFns = []

export { render, staticRenderFns }